




















import { Component, Vue } from 'vue-property-decorator';
import { IUNCService } from '@/services/iUNCService';
import { ObjectFactory } from '@/config/objectFactory';
@Component
export default class UNCCallback extends Vue {
  private uncService: IUNCService = ObjectFactory.getUNCService();
  private hasError = false;
  private errorMessage = '';
  private errorCode = '';
  public async mounted() {
    try {
      // Handle the UNC callback
      const clientId = this.$store.getters.SSOclientId;
      await this.uncService.handleCallback(clientId);
      // If successful, the service will reload the page and redirect
    } catch (error) {
      this.handleError(error);
    }
  }

  private handleError(error: any) {
      this.hasError = true;
      // Default fallback message
      const defaultMessage = 'Authentication failed. Please try again.';
      try {
          let errorData = null;
          // Extract error data
          if (typeof error.message === 'string') {
              const jsonMatch = error.message.match(/\{.*\}/);
              if (jsonMatch) {
                  errorData = JSON.parse(jsonMatch[0]);
              }
          } else if (error.response && error.response.data) {
              errorData = error.response.data;
          } else if (typeof error === 'object') {
              errorData = error;
          }
          // Show errorCode if available, otherwise default message
          if (errorData && errorData.errorCode) {
              this.errorMessage = errorData.errorCode;
          } else {
              this.errorMessage = defaultMessage;
          }

      } catch (parseError) {
          this.errorMessage = defaultMessage;
      }
  }
}
